import React, { useState, useEffect, useCallback } from 'react';
import { Space } from 'antd';
import request from '../../../../logic/utils/request';
import ZonesTable from './ZonesTable';
import NewZone from './NewZone/NewZone';
import { Title, ContentBox, PreloaderBox } from '../../../../common/ui/Common';
import { useToggle } from '../../../../logic/hooks/useToggle';
import ImportZoneButton from '../../../../pages/private/subpages/zones/ImportZoneButton';

function HandlePoints({ preloader, showError }) {
  const initialData = {
    name: '', longname: '', description: '', config: { params: [], screens: [] },
  };
  const [zoneList, setZoneList] = useState(null);
  const [zoneData, setZoneData] = useState(initialData);
  const [isOpen, toggleOpen] = useToggle(false);
  const [zoneUpdate, setZoneUpdate] = useState(false);

  const fetchZones = useCallback(async () => {
    const res = await request('/server/api/zone/', 'get');
    setZoneList(res.data.data);
  }, []);

  useEffect(() => {
    fetchZones();
  }, [fetchZones]);

  const handleImport = (zone) => {
    setZoneUpdate(false);
    setZoneData({ ...initialData, ...zone });
    if (!isOpen) toggleOpen();
  };

  return (
    <>
      <Title>Зоны обслуживания</Title>
      <ContentBox>
        <Space>
          <NewZone
            initialData={initialData}
            zoneData={zoneData}
            setZoneData={setZoneData}
            toggleOpen={toggleOpen}
            isOpen={isOpen}
            zoneUpdate={zoneUpdate}
            setZoneUpdate={setZoneUpdate}
            fetchZones={fetchZones}
            showError={showError}
            preloader={preloader}
          />
          <ImportZoneButton onImport={handleImport} />
        </Space>
        <PreloaderBox>
          <ZonesTable
            zoneList={zoneList}
            setZoneUpdate={setZoneUpdate}
            setZoneData={setZoneData}
            toggleOpen={toggleOpen}
            preloader={preloader}
            fetchZones={fetchZones}
            showError={showError}
          />
        </PreloaderBox>
      </ContentBox>
    </>
  );
}

export default HandlePoints;
